import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const AppLoadingScreen: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="fixed inset-0 bg-gradient-to-br from-primary/5 via-white to-accent/5 flex items-center justify-center z-50">
            <div className="text-center">
                {/* Logo */}
                <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                    className="mb-8"
                >
                    <img
                        src="/logo.png"
                        alt="Farhan Bio"
                        className="h-16 w-auto mx-auto"
                    />
                </motion.div>

                {/* Loading Text */}
                <motion.p
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                    className="text-neutral-600 font-medium mb-6"
                >
                    {t('loading.title', 'Chargement en cours...')}
                </motion.p>

                {/* Progress Dots */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                    className="flex gap-3 justify-center"
                >
                    {[0, 1, 2].map((i) => (
                        <motion.div
                            key={i}
                            className="w-3 h-3 bg-primary rounded-full"
                            animate={{
                                scale: [1, 1.5, 1],
                                opacity: [0.3, 1, 0.3]
                            }}
                            transition={{
                                duration: 1.5,
                                repeat: Infinity,
                                delay: i * 0.2
                            }}
                        />
                    ))}
                </motion.div>
            </div>
        </div>
    );
};

export default AppLoadingScreen;
